import { render } from "./PageDrawer.vue?vue&type=template&id=325fc37e"
import script from "./PageDrawer.vue?vue&type=script&lang=js"
export * from "./PageDrawer.vue?vue&type=script&lang=js"

import "./PageDrawer.vue?vue&type=style&index=0&id=325fc37e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__